import axios from "axios";

const getSessionStorageDetails = () => {
  return JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
};

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_ENDPOINT}`,
  responseType: "json",
  headers: {
    "Content-type": "application/json",
  },
});

instance.interceptors.request.use(
  (config) => {
    const { token_type, access_token } = getSessionStorageDetails();
    config.headers.Authorization = `${token_type} ${access_token}`;
    if (config.hasDefaultURL) {
      config.url = `${config.baseURL}/${config.url}`;
    } else {
      config.url = `${config.baseURL}/${process.env.REACT_APP_ENDPOINT_POSTFIX}${config.url}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;
